import * as $ from 'jquery'
import { Router } from '@angular/router';
import { AppService } from './../../service/app.service';
import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { NavbarService } from '../../service/navbar.service';
import { AuthService } from './../../service/auth.service';

@Component({
  selector: 'app-top-menu-bar',
  templateUrl: './top-menu-bar.component.html',
  styleUrls: ['./top-menu-bar.component.scss']
})
export class TopMenuBarComponent implements OnInit{
  electionModel: string;
  @Output() notifyViewChange = new EventEmitter();
  loggedIn: boolean;

  constructor(private router: Router,
    private authService: AuthService,
    private appService: AppService,
    public _navbarService: NavbarService) {
    this.electionModel = JSON.parse((<any>document.getElementById('model')).value);
     
    this.loggedIn = this.authService.isLoggedIn;

  }


  ngOnInit() {
    this._navbarService.show();
    this.skipLink();
  }

  gotoHelp() {
    this.router.navigate(['/help']);
  }

  gotoSettings() {
    this.router.navigate(['/settings']);
  }

  logout() {
    // the user/Voter is already logged out at this point.
    this.appService.clearAll();
    this.router.navigate(['/']);
  }

  skipLink() {
    $('h1.titleHeading').focus();
  }

  voteSummary() {
    this.router.navigate(['/ballot-review']);
  }

}



// WEBPACK FOOTER //
// ./src/app/features/top-menu-bar/top-menu-bar.component.ts